export const menuItemsAdminData = [
  {
    title: 'Dashboard',
    url: '/authorizations/dashboard',
  },
  {
    title: 'Settings',
    submenu: [
      {
        title: 'Approved Capital Projects',
        url: '/authorizations/settings/approvedCapitalProjects',
      },
      {
        title: 'Funds Email',
        url: '/authorizations/settings/fundsemail',
      },
      {
        title: 'Authorization Verbiage',
        url: '/authorizations/settings/verbiage',
      },
      {
        title: 'Authorization Types',
        url: '/authorizations/settings/types',
      },
      {
        title: 'Approver Levels',
        url: '/authorizations/settings/approverlevels',
      },
      {
        title: 'Approvers',
        url: '/authorizations/settings/approvers',
      },
      {
        title: 'Funds',
        url: '/authorizations/settings/funds',
      }
    ]
  },
  {
    title: 'Reports',
    submenu: [
      {
        title: 'Administration of Investments',
        url: '/authorizations/reports/administrationOfInvestments',
      },
      {
        title: 'Investment Activity Summary',
        url: '/authorizations/reports/investmentActivitySummary',
      }
    ]
  }
];

export const menuItemsManagerData = [
  {
    title: 'Dashboard',
    url: '/authorizations/dashboard',
  },
  {
    title: 'Reports',
    submenu: [
      {
        title: 'Administration of Investments',
        url: '/authorizations/reports/administrationOfInvestments',
      },
      {
        title: 'Investment Activity Summary',
        url: '/authorizations/reports/investmentActivitySummary',
      }
    ]
  }
];
const headerpath = window.location.pathname;


export const menuItemsExternalUserData = [
  {

    
    
    title: 'Dashboard',
    url: '/authorizations/dashboard',
  }

  
];